/**
 * Gets the numeric Value from a money string with currency
 * decimal separator can be dot(.) or comma (,)
 * @param {String|int} value - The value to format
 * @returns {number|null} - The value formatted
 */
function getNumericValue(value) {
  const regex = /(\d+)+[.,]?(\d+)?/;
  if (!value || !value.toString().match(regex) || value.toString().match(regex).length === 0) {
    return null;
  }
  const valueStr = value.toString();
  return parseFloat(valueStr.match(regex)[0]);
}

module.exports = {
  getNumericValue,
};
